export const READER_SUPPORT_URL = 'https://buymeacoffee.com/microplasticsteam'
export const READER_SUPPORT_OFFER = 'reader_support_v1'

export type SupportSurface = 'article_comparison' | 'article_takeaways' | 'article_end' | 'nav_desktop' | 'nav_mobile' | 'footer'

/** Only placement labels cross to the payment provider, never visitor IDs or answers. */
export function readerSupportUrl(surface: SupportSurface): string {
  const url = new URL(READER_SUPPORT_URL)
  url.searchParams.set('utm_source', 'microplasticsapp')
  url.searchParams.set('utm_medium', 'website')
  url.searchParams.set('utm_campaign', READER_SUPPORT_OFFER)
  url.searchParams.set('utm_content', surface)
  return url.toString()
}

export function supportPosition(surface: SupportSurface): string {
  if (surface.startsWith('nav_')) return 'navigation'
  if (surface === 'footer' || surface === 'article_end') return 'bottom'
  return 'mid_article'
}
